import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE } from '../../utils/clientCancellationLines/clientCancellationLinesLabels';

interface SuspensionBlockBannerProps {
  /** Quando false, não renderiza nada */
  active?: boolean;
  size?: 'small' | 'tiny';
  /** `warning` = contrato sem suspensão; `info` = política/cutoff informativo */
  variant?: 'warning' | 'info';
  header?: string;
  message?: string;
}

export const SuspensionBlockBanner: React.FC<SuspensionBlockBannerProps> = ({
  active = true,
  size = 'small',
  variant = 'warning',
  header,
  message,
}) => {
  if (!active) return null;
  const texto = message?.trim() || CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE;
  const titulo =
    header ??
    (variant === 'info' ? 'Política de suspensão (1056)' : 'Suspensão indisponível neste contrato');
  return (
    <Message warning={variant === 'warning'} info={variant === 'info'} size={size} data-testid="banner-suspensao-1056">
      <Icon name={variant === 'info' ? 'info circle' : 'ban'} />
      <Message.Header>{titulo}</Message.Header>
      <p style={{ marginBottom: 0 }}>{texto}</p>
    </Message>
  );
};

export default SuspensionBlockBanner;
